"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TabContentComponent.default;
  }
});

var _TabContentComponent = _interopRequireDefault(require("./TabContent-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }